import { BookX } from "lucide-react"

import { Label } from "@ui/label"
import { Textarea } from "@ui/textarea"

import { CollectionItem } from "@vertesia/common"

interface ReportAdditionalDetailsPanelProps {
    configuration: CollectionItem
    additional: Record<string, string>
    setAdditional: (additional: Record<string, string>) => void
}
export function ReportAdditionalDetailsPanel({ configuration, additional, setAdditional }: Readonly<ReportAdditionalDetailsPanelProps>) {
    const additionalFields = (configuration as any)?.properties?.additional || []

    return (
        <div className="space-y-2 flex-1 flex flex-col">
            {
                additionalFields.length > 0
                    ? (
                        <>
                            {
                                additionalFields.map((field: any, index: number) => (
                                    <div key={index} className="flex flex-col h-full">
                                        <Label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                                            {field.name}{field.required ? <span className="text-red-500">*</span> : <span className="text-muted-foreground"> (optional)</span>}
                                        </Label>
                                        <Textarea
                                            value={additional[field.name] || ""}
                                            onChange={(e) => setAdditional({ ...additional, [field.name]: e.target.value })}
                                            placeholder={field.placeholder}
                                            className="min-h-[80px] flex-1"
                                        />
                                    </div>
                                ))
                            }
                        </>
                    ) : (
                        <div className='flex flex-col items-center justify-center h-full gap-2'>
                            <BookX className="h-16 w-16 mx-auto text-gray-300" />
                            <div className='text-center'>
                                <p className="text-lg font-medium text-gray-600">
                                    No Additional Information Needed
                                </p>
                            </div>
                        </div>
                    )
            }
        </div>
    )
}
